module.exports = __webpack_public_path__ + "img/ffsinvate-h5.a80d919.png";